import styles from "./categories-skin-6.module.css";
import { useCategories } from "../../categories.hook";
import { CSSProperties, useMemo } from "react";
import { ButtonRoundedClass, ButtonRoundedEnum, resizeImage } from "@commons-monorepo/index";
import WidgetContainer from "../../../widget-container";
import { UiButton } from "@ui-monorepo/components";

const CategoriesSkin6 = () => {
  const { categories: allCategories, theme } = useCategories(4);

  const categories = useMemo(() => {
    return Array.isArray(allCategories) ?
    [...allCategories].filter((category) => {
      return !category.className.includes("view-more");
    }) :
    [];
  }, [allCategories]);

  const imageStyle = (category: CSSProperties) => {
    return {
      background: `
        linear-gradient(
          180deg,
          rgba(0, 0, 0, 0.00) 0.75%,
        rgba(87, 87, 87, 0.50) 94.73%),
        url(${resizeImage(category.image, 0, 0, 60)}),
        lightgray 50% / cover no-repeat`,
      backgroundSize: "cover"
    };
  };
  const styleButtonType = useMemo(
    () =>
    theme?.config?.button?.rounded === ButtonRoundedEnum.full ?
    ButtonRoundedClass.rounded :
    theme?.config?.button?.rounded === ButtonRoundedEnum.semi ?
    ButtonRoundedClass.mid_rounded :
    theme?.config?.button?.rounded === ButtonRoundedEnum.square ?
    ButtonRoundedClass.square :
    "",
    [theme]
  );

  return (
    <WidgetContainer className={styles.widgetContainer} containerClassName={styles.widgetContainerContent}>
      <div
        className={`${styles.categoriesSkin6Container} ${
        styles[`categoriesSkin6ContainerLayout${categories.length}`]
        } ${styles[`categoriesSkin6Container${categories.length % 2 === 0 ? "Par" : "Impar"}`]}`}>

        {categories.map((category: any, index: number) =>
        <div onClick={category.onClick} key={`key-${index}`} className={`${styles[category.className]}`}>
            <div className={styles.categoryName}>
              <span>{category.name}</span>
            </div>
            <div className={`${styles.image}`} style={imageStyle(category)}>
              <div className={`${styles.arrow} && ${styles[styleButtonType]}`}>
                <UiButton
                appearance='icon'
                className={styles.viewMoreCategory6}
                leftIcon={<div className='icon-arrow-right' />}
                theme={theme} />

              </div>
            </div>
          </div>
        )}
      </div>
    </WidgetContainer>);

};

export default CategoriesSkin6;